export default function(data) {
  var self = this;
  self.$el = $('#admin_dashboard');
  self.$firstNameSearchEl = $('#instructor_search_first_name');
  self.$lastNameSearchEl = $('#instructor_search_last_name');
  self.$emailSearchEl = $('#instructor_search_email');
  self.selectedInstructor = ko.observable({
    first_name: ko.observable(),
    last_name: ko.observable(),
    email: ko.observable(),
    role: ko.observable('Instructor')
  });

  self.initUI = function() {
    self.initTypeaheads();
  };

  self.resetSelectedInstructor = function() {
    self.client_errors = ko.validation.group(self.selectedInstructor(), { deep: true });
    self.selectedInstructor().first_name('');
    self.selectedInstructor().last_name('');
    self.selectedInstructor().email('');
    self.client_errors.showAllMessages(false);
  };

  self.initSearchEngine = function(type) {
    var instructorSearch = new Bloodhound({
      datumTokenizer: Bloodhound.tokenizers.obj.whitespace(type),
      queryTokenizer: Bloodhound.tokenizers.whitespace,
      limit: 5,
      remote: {
        url: Kadenze.Routes.list_admin_users_path({ q: '%QUERY', type }),
        filter: function(instructors) {
          return $.map(instructors, function(instructor) { return { name: instructor.full_name, first_name: instructor.first_name, last_name: instructor.last_name, email: instructor.email.trim() }; });
        },
        ajax: {
          dataType: 'json',
          contentType: 'application/json',
          beforeSend: function() {
            //TODO: Show progress indicator
            $('.status_indicator').html('Searching...');
          },
          complete: function() {
            //TODO: Hide progress indicator
            $('.status_indicator').html('');
          }
        }
      }
    });

    instructorSearch.initialize();

    return instructorSearch;
  };

  self.initTypeahead = function($element, key) {
    var searchEngine = self.initSearchEngine(key);

    $element.typeahead({
      hint: false,
      highlight: true,
      minLength: 1
    },
    {
      name: 'instructors',
      displayKey: key,
      source: searchEngine.ttAdapter()
    });

    $element.on('typeahead:selected', self.resultsSelected);
  };

  self.resultsSelected = function(obj, datum) {
    self.selectedInstructor().first_name(datum.first_name);
    self.selectedInstructor().last_name(datum.last_name);
    self.selectedInstructor().email(datum.email);
  };

  self.initTypeaheads = function() {
    self.initTypeahead(self.$firstNameSearchEl, 'first_name');
    self.initTypeahead(self.$lastNameSearchEl, 'last_name');
    self.initTypeahead(self.$emailSearchEl, 'email');
  };

  self.inviteInstructor = function(item, event) {
    self.client_errors = ko.validation.group(self.selectedInstructor(), { deep: true });
    if (self.client_errors().length === 0) {
      self.sendInvitation();
    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.sendInvitation = function() {
    var url = Kadenze.Routes.institution_invite_admin_instructors_path();
    var method = 'POST';
    var data = null;

    data = {instructor: ko.mapping.toJS(self.selectedInstructor())};

    Kadenze.UIUtil.makeRequest(url, method, data, self.$el, null, function(data, textStatus, xhr) {
      Kadenze.UIUtil.showNotice($('#notice_container'), data, 5000);
      self.resetSelectedInstructor();
    }, function(xhr, textStatus, errorThrown) {
      Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 5000);
    });
  };

  const __construct = function(that) {
    that.course_id = $('#course_id').val();
    console.log('constructor called for CourseInstructorInviteViewModel');

  }(this);
}

